import { Injectable } from "@angular/core";
import { LoginService } from "./login.service";
import { SalesRep } from "../models/sales-rep.model";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { BACKEND_URI } from "../config/config-vars";
import { Game } from "../models/game.model";

const BASE_URL = `${BACKEND_URI}/api/game`;
const GET_ALL_URL = BASE_URL;
const INSERT_URL = BASE_URL;
const UPDATE_URL = (id) => `${BASE_URL}/${id}`;
const GET_BY_ID_URL = (id) => `${BASE_URL}/${id}`;
const DELETE_BY_ID_URL = (id) => `${BASE_URL}/${id}`;


@Injectable({providedIn: 'root'})
export class GameService {
    constructor(private http: HttpClient, private loginService: LoginService){}
    
    async getAll(): Promise<Game[]> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<Game[]>(GET_ALL_URL)
            );
        }
    }

    async getById(id): Promise<Game> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<Game>(GET_BY_ID_URL(id))
            );
        }
    }
    async create(data: Game): Promise<Game> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.post<Game>(INSERT_URL, data)
            );
        }
    }
    async update(id, data: Game): Promise<Game> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.put<Game>(UPDATE_URL(id), data)
            );
        }
    }

    async delete(id): Promise<void> {
        if(this.loginService.isloggedIn) {
            try{
                await firstValueFrom(
                    this.http.delete(DELETE_BY_ID_URL(id))
                );

            } catch(err) {}            
        }
      }
}